import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Button from "@client.components/Button";
import UserManagementContent from "@client.components/UserManagementContent";
import {
  clearUserManagementError,
  createUserAsync,
} from "@client.pages/Settings/reducer";
import InvitationNotificationContent from "./InvitationNotificationContent";
import useModal from "@client.hooks/useModal";
import ServiceProvider from "@client.services/provider";
import { MODAL_EVENT } from "@client.components/Modal";
import { useDemo } from "@client.hooks/useDemo";

const AddUserButton = () => {
  const { t } = useTranslation();
  const { showFormModal, showModal } = useModal();
  const dispatch = useDispatch();
  const { withDemoCheck } = useDemo();

  const addUserText = t("components.UsersDataTable.addUser");

  const onClick = useCallback(() => {
    withDemoCheck(() => showFormModal({
      title: addUserText,
      component: <UserManagementContent />,
      onClose: () => {
        dispatch(clearUserManagementError());
      },
      footerButtons: [
        {
          icon: "plus",
          onClick: (managementItem) =>
            dispatch(createUserAsync(managementItem)),
          onSuccess: (managementItem) => {
            if (managementItem.sendInvite) {
              showModal({
                title: t("components.UsersDataTable.inviteUser"),
                component: (
                  <InvitationNotificationContent user={managementItem} />
                ),
                footerButtons: [
                  {
                    text: t("components.Modal.FooterButtons.greatThanks"),
                    onClick: () => Promise.resolve({}),
                  },
                ],
              });
            } else {
              ServiceProvider.EventEmitter.emit(MODAL_EVENT, {
                show: false,
              });
            }
          },
        },
      ],
    }));
  }, [dispatch, addUserText, showModal, showFormModal, t, withDemoCheck]);

  return <Button icon="plus" text={addUserText} onClick={onClick} />;
};

export default AddUserButton;
